// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ValidityDatesRuleResponse

import { BookingRuleType } from './enums.gen';

export type ValidityDatesRuleApiResponse = {
	type: BookingRuleType.ValidityDates;
	validityDates: Array<string> | null;
};

export type ValidityDatesRule = {
	type: BookingRuleType.ValidityDates;
	validityDates: Array<string> | null;
};

export function hydrateValidityDatesRule(data: ValidityDatesRuleApiResponse): ValidityDatesRule {
	return { ...data };
}